import { FC } from 'react';
import './index.css';
import { Row, Col, Typography } from 'antd';

import { Modal } from '@hdi-seguros/web-components.modal';

interface ConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  confirmButtonLabel: string;
  title: string;
  description: string | React.ReactNode;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
  confirmButtonLabel,
  title,
  description
}) => {
  return (
    <Modal
      centered
      open={ open }
      className='confirmation-modal-container'
      title={ title }
      onCancel={ onCancel }
      onOk={ onConfirm }
      confirmText={ confirmButtonLabel }
      footer
    >
      <Row align='middle' justify='end' className='confirmation-modal-row'>
        <Col span={24}>
          <Typography.Text>
            { description }
          </Typography.Text>
        </Col>
      </Row>
    </Modal>
  );
};
